var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.844821 5.23828C0.490269 5.23828 0.283384 4.83821 0.488321 4.54889L3.35693 0.49909C3.53104 0.253286 3.89582 0.253286 4.06993 0.49909L6.93853 4.54889C7.14347 4.83821 6.93658 5.23828 6.58203 5.23828H0.844821Z",
    fill: "#2D2C2C",
    stroke: "#236DFF",
    strokeWidth: 0.262124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.844821 7.99609C0.490269 7.99609 0.283384 8.39617 0.488321 8.68549L3.35693 12.7353C3.53104 12.9811 3.89582 12.9811 4.06993 12.7353L6.93853 8.68549C7.14347 8.39616 6.93658 7.99609 6.58203 7.99609H0.844821Z",
    fill: "#2D2C2C",
    stroke: "#236DFF",
    strokeWidth: 0.262124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNormal);
export default __webpack_public_path__ + "static/media/filterNormal.38ffb5518a9dd469089ea098b8fec3c3.svg";
export { ForwardRef as ReactComponent };